import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../shared/shared.service';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';
import { AreaService } from './area.service';
@Component({
  selector: 'app-area',
  templateUrl: './area.component.html',
  styleUrls: ['./area.component.scss']
})
export class AreaComponent implements OnInit {
  bucketurl = environment.bucketUrl;
  displayedColumns: string[] = ['SNo', 'area','area_code' , 'district', 'region', 'state', 'zone', 'country', 'status', 'action'];
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);

  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  areaForm: FormGroup;
  isLoading: Subject<boolean> = new Subject<boolean>();
  public searchInput = new FormControl("");

  constructor(private toastr: ToastrService, private fb: FormBuilder, private sharedService: SharedService, private areaService: AreaService) {
    this.areaForm = this.fb.group({
      areaName: ['', Validators.required],
      areaCode: [''],
      country: ['', Validators.required],
      zone: ['', Validators.required],
      state: ['', Validators.required],
      region: ['', Validators.required],
      district: [''],
      status: ['', Validators.required]
    });
  }

  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;

  ngOnInit() {
    this.getList();
    this.getCountryList();
    this.searchInput.valueChanges.subscribe(() => {
      this.applyFilter();
    });
  }

  get f() { return this.areaForm.controls; }

  add() {
    this.isCreate = true;
  }

  selectedObject: any = {}
  editData(object: any) {
    this.isEdit = true;
    this.selectedObject = object;
    this.getZoneList(object?.district?.state?.country?.id);
    this.getStateList(object?.district?.state?.zone?.id);
    this.getRegionList(object?.district?.state?.id);
    this.getDistrictList(object?.district?.region?.id);
    this.areaForm.patchValue({
      areaName: object?.area_name,
      areaCode: object?.area_code,
      country: object?.district?.state?.country?.id,
      zone: object?.district?.state?.zone?.id,
      state: object?.district?.state?.id,
      region: object?.district?.region?.id,
      district: object?.district?.id,
      status: object.status ? 1 : 0
    })
  }

  back() {
    this.clearForm();
    this.selectedObject = {};
    this.isCreate = false;
    this.isEdit = false;
    this.getList();
  }

  applyFilter() {
    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';  
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const area = data.area_name.toLowerCase().includes(filter);
      // const areaCodeMatch = data.area_code.includes(filter);
      const areaCodeMatch = data.area_code && data.area_code.toString().includes(filter);
      
      return area || areaCodeMatch;
    };
      this.dataSource.filter = filterValue;
  }

  clearSearch() {
    this.searchInput.setValue(''); // Clear the search input
    this.applyFilter();
  }

  create() {
    this.submitted = true
    if (this.areaForm.valid) {
      const areaData = this.areaForm.value;
      let obj = {
        "area_name": areaData.areaName,
        "area_code": areaData.areaCode,
        "district_id": parseInt(areaData.district),
        "status": parseInt(areaData.status)
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.areaService.createArea(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Area created successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  update() {
    this.submitted = true
    if (this.areaForm.valid) {
      const areaData = this.areaForm.value;
      let obj = {
        "area_name": areaData.areaName,
        "area_code": areaData.areaCode,
        "district_id": areaData.district,
        "status": parseInt(areaData.status)
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.areaService.updateArea(obj, this.selectedObject.id).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Area updated successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  clearForm() {
    this.submitted = false;
    this.areaForm.patchValue({
      state: '',
      country: '',
      zone: '',
      region: '',
      district: '',
      areaName: '',
      areaCode: '',
      status: ''
    });
    this.zoneList = [];
    this.stateList = [];
    this.regionList = [];
    this.districtList = [];    
  }

  allowNumbersHyphenOnly(event: any) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[0-9\-]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  getList() {
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.areaService.getArea().subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  countryList: any = []
  getCountryList() {
    this.areaService.getCountry().subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.countryList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }


  zoneList: any = []
  getZoneList(countryId?: any) {
    this.zoneList = []
    let id: any = this.areaForm.value.country ? this.areaForm.value.country : countryId
    this.areaService.getZoneByCountry(id).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.zoneList = responseData.data;
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }


  stateList: any = []
  getStateList(zoneId?: any) {
    this.stateList = []
    this.regionList = [];
    this.districtList = []
    this.areaForm.patchValue({state:'', region:'', district:''})
    let id: any = this.areaForm.value.zone ? this.areaForm.value.zone : zoneId;
    this.areaService.getStateByZone(id).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.stateList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  regionList: any = []
  getRegionList(stateId?: any) {
    this.regionList = []
    this.districtList = []
    this.areaForm.patchValue({region:'', district:''})
    let id: any = this.areaForm.value.state ? this.areaForm.value.state : stateId;
    this.areaService.getRegionByState(id).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.regionList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  districtList: any = []
  getDistrictList(regionId?: any) {
    this.districtList = []
    this.areaForm.patchValue({district:''})
    let id: any = this.areaForm.value.region ? this.areaForm.value.region : regionId;
    this.areaService.getDistrictByRegion(id).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.districtList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }
}
